import { Box, Typography } from "@mui/material";
import { T } from "./tokens";
import { NeedsAttentionPanel, OwedWorkPanel, TeamPositionPanel } from "./overviewPanels";
import type { WeeklyVisitSummary } from "./data";

const Overview = ({
    data,
    isLoading,
    isError,
    team,
    dates,
    onGoSchedule,
    onGoConsultants,
    onGoPool,
    onGoReports,
}: {
    data: WeeklyVisitSummary | null | undefined;
    isLoading: boolean;
    isError: boolean;
    team: string;
    dates: Date[];
    onGoSchedule: (gapsOnly?: boolean) => void;
    onGoConsultants: (nothingBookedOnly?: boolean) => void;
    onGoPool: () => void;
    onGoReports: () => void;
}) => {
    const nav = { onGoSchedule, onGoConsultants, onGoPool, onGoReports };
    // The org-wide summary is gated on the Salesforce H&S Admin flag.
    const gated = !isLoading && !isError && !data;

    return (
        <Box sx={{ padding: "24px 28px", display: "flex", flexDirection: "column", gap: "18px" }}>
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: "1.15fr 1fr",
                    gap: "18px",
                    alignItems: "stretch",
                    "@media (max-width:1200px)": { gridTemplateColumns: "1fr" },
                }}
            >
                <NeedsAttentionPanel
                    data={data}
                    isLoading={isLoading}
                    isError={isError}
                    team={team}
                    dates={dates}
                    nav={nav}
                />
                {!gated && <OwedWorkPanel team={team} nav={nav} />}
            </Box>

            {!gated && <TeamPositionPanel data={data} isLoading={isLoading} isError={isError} dates={dates} nav={nav} />}

            {gated && (
                <Box sx={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: "12px", padding: "18px 20px" }}>
                    <Typography sx={{ fontSize: "13px", color: T.ink2, lineHeight: 1.6 }}>
                        Tandem plans and measures the whole team&apos;s diaries, so every screen needs the
                        org-wide visit summary. The API returns it only to users flagged <b>H&amp;S Admin</b> on
                        their Salesforce employee record — ask whoever owns that flag to add you.
                    </Typography>
                </Box>
            )}
        </Box>
    );
};

export default Overview;
